// Campus photo for /colleges/clemson-university: CC BY-SA 2.0, by Dick Rochester from Lafayette, Colorado, United States, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ATillman_Hall_January_2008.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/clemson-university/; credited under the photo.
const photo = {
    "slug": "clemson-university",
    "alt": "Tillman Hall and its brick clock tower behind bare winter trees at Clemson University",
    "src": "/colleges/clemson-university/campus-1600.webp",
    "srcSmall": "/colleges/clemson-university/campus-800.webp",
    "srcMid": "/colleges/clemson-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/clemson-university/og.jpg",
    "title": "Tillman Hall January 2008",
    "author": "Dick Rochester from Lafayette, Colorado, United States",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ATillman_Hall_January_2008.jpg",
    "read": "2026-10-01"
};

export default photo;
